import React from "react";
export { default as EditTerritoryForm } from "./components/EditTerritoryForm";
export const CreateTerritoryWizard = React.lazy(
  () =>
    import(
      /* webpackPrefetch: true */
      "./components/CreateTerritoryWizard"
    )
);
